import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import * as _ from 'lodash';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';

export const useTeamNews = (abbrv) => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/team/news?id=${abbrv}`)
      .then((response) => {
        const parsedData = response?.data?.documents
          .map((item) => FireStoreParser(item))
          .map((item) => item.fields);
        setData(parsedData);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [abbrv, endpointUrl, setData]);

  return [_.uniqBy(data, 'articleUrl'), loading, error];
};
